import { Capacitor } from "@capacitor/core";

const EDITABLE = "input, textarea, select, [contenteditable=true]";
const INTERACTIVE = "button, a[href], [role=button], [role=menuitem], [role=tab], [role=checkbox], [role=switch], [role=option], label, summary, [data-radix-dialog-overlay], [data-ios-tap]";
const MOVE_TOLERANCE = 12;
const LONG_PRESS_MS = 500;

const isIosNative = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios";
const isEditable = (el) => !!el?.closest?.(EDITABLE);
const synth = (type, target, t) =>
  target.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window, clientX: t.clientX, clientY: t.clientY, button: 0 }));

// iOS native shell + keyboard open: tapping a button inside a modal first blurs the
// field → the keyboard hides → the WebView is resized (Keyboard resize=native) while
// the tap is still in flight → the tap is lost (X / J'aime / Répondre needed 2-3 taps).
// For taps on INTERACTIVE targets we swallow the native tap→click sequence (the field
// keeps focus, keyboard stays up) and dispatch the click ourselves. Taps on plain
// background still dismiss the keyboard as usual. No-op on web / Android.
export function iosKeyboardTouchEnd(e) {
  if (!isIosNative() || e.defaultPrevented || !e.cancelable || e.touches?.length) return;
  if (!isEditable(document.activeElement)) return;
  const t = e.changedTouches[0];
  const target = e.target;
  if (!t || !target || isEditable(target)) return;
  const interactive = target.closest?.(INTERACTIVE);
  if (!interactive) return;
  const start = e.currentTarget.__iosTap;
  if (start && (Math.hypot(t.clientX - start.x, t.clientY - start.y) > MOVE_TOLERANCE || Date.now() - start.at > LONG_PRESS_MS)) return;
  e.preventDefault();
  synth("mousedown", target, t);
  synth("mouseup", target, t);
  synth("click", target, t);
}

export function iosKeyboardTouchStart(e) {
  if (!isIosNative()) return;
  const t = e.touches[0];
  e.currentTarget.__iosTap = t ? { x: t.clientX, y: t.clientY, at: Date.now() } : null;
}

export const iosKeyboardTapProps = { onTouchStart: iosKeyboardTouchStart, onTouchEnd: iosKeyboardTouchEnd };
